import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { LoadingWolf } from '@platform/client/components/svgs/loading-wolf';

import { routes } from './routes';

import '../locales/i18n';

const FullscreenLoadingWolf = () => (
  <div
    style={{
      display: 'grid',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyItems: 'center',
    }}
  >
    <LoadingWolf />
  </div>
);

const router = createBrowserRouter(routes);

const App = () => {
  return (
    <RouterProvider
      router={router}
      fallbackElement={<FullscreenLoadingWolf />}
      future={{
        v7_startTransition: true,
      }}
    />
  );
};

export default App;
